import { type ReactNode } from "react";

import { FieldWithLabel } from "src/components/FieldWithLabel";

interface SectionFieldRowProps {
  label: string;
  renderField: (id: string) => ReactNode;
}

export function SectionFieldRow(props: SectionFieldRowProps) {
  return (
    <FieldWithLabel
      label={props.label}
      className="flex-row items-center gap-1.5"
      labelClassName="text-xs font-medium text-slate-500"
      renderField={props.renderField}
    />
  );
}
